import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { StudentPortalService } from 'src/app/services/student-portal.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-signin-redirect-callback',
    template: `<div
        style="width: 100vw; height: 100vh; position: absolute; z-index: 999;"
    ></div>`,
})
export class SigninRedirectCallbackComponent implements OnInit {
    constructor(
        private _authService: AuthService,
        private _router: Router,
        private _portalService: StudentPortalService,
    ) {}

    async ngOnInit(): Promise<void> {
        this._authService.finishLogin().then(async (_) => {
            const user = await firstValueFrom(this._authService.currentUser$);
            const id = await firstValueFrom(
                this._portalService.getStudentIdByEmail()
            );
            if (id === 0) {
                await this._authService.revoke();
                this._router.navigate(['no-email']);
            } else {
                this._router.navigate([`/profile`]);
            }
        });
    }
}
